






























import {Component, Vue} from "vue-property-decorator";
import upload from "@/components/upload/src/index.vue";
import {
  getAbnormalOrderExcel,
  getAbnormalOrderExcelTemplate,
  saveAbnormalOrderExcel,
} from "@/services/api";

@Component({
  components: {
    'zf-upload': upload,
  },
})

export default class OrderParse extends Vue {

  // excel下载截流控制
  public excelCtrl = true;
  // 上传的excel文件名称
  private excelName: string = "";

  /**
   * excel上传
   */
  async handleUploadChange(i: any) {
    try {
      if (i.target?.files?.length > 0) {
        this.excelName = i.target.files[0].name;
        let params = new FormData();
        params.append('file', i.target.files[0]);
        await saveAbnormalOrderExcel(params).then(res => {
          if (res.data && res.data.code === 200) {
            this.$message.success(res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        })
      }
      i.target.value = '';
    } catch (e) {
      console.log(e)
    }
  }


  /**
   * excel下载
   */
  async getOrderExcel(): Promise<void> {
    if (this.excelCtrl) {
      this.excelCtrl = false;
      let me = this;
      try {
        await getAbnormalOrderExcel().then((res: any) => {
          const contentType = res.headers['content-type'];
          //和后端约定，如果返回类型是json则说明excel不可下载，读取json数据展示提示信息
          if (contentType === 'application/json;charset=utf-8') {
            const blob = new Blob(
              [res.data], {type: 'application/json;charset=utf-8'});
            blob.text().then(function (data) {
              me.$message.error(JSON.parse(data)['message']);
            });
            return;
          }

          const blob = new Blob(
            [res.data], {type: 'application/vnd.ms-excel; chartset=utf-8'})
          const aEle = document.createElement('a');     // 创建a标签
          const href = window.URL.createObjectURL(blob);       // 创建下载的链接
          aEle.href = href;
          aEle.download = decodeURI(res.headers['content-disposition'].replace('attachment;filename=', ''));  // 下载后文件名
          document.body.appendChild(aEle);
          aEle.click();     // 点击下载
          document.body.removeChild(aEle); // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        })
      } catch (e) {
        console.log(e)
      }
      this.excelCtrl = true;
    }

  }

  /**
   * excel模板下载
   */
  async getOrderExcelTemplate(): Promise<void> {
    if (this.excelCtrl) {
      this.excelCtrl = false;
      try {
        await getAbnormalOrderExcelTemplate().then((res: any) => {
          const blob = new Blob(
            [res.data], {type: 'application/vnd.ms-excel; chartset=utf-8'})
          const aEle = document.createElement('a');     // 创建a标签
          const href = window.URL.createObjectURL(blob);       // 创建下载的链接
          aEle.href = href;
          aEle.download = decodeURI(res.headers['content-disposition'].replace('attachment;filename=', ''));  // 下载后文件名
          document.body.appendChild(aEle);
          aEle.click();     // 点击下载
          document.body.removeChild(aEle); // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        })
      } catch (e) {
        console.log(e)
      }
      this.excelCtrl = true;
    }

  }

  /**
   * excel上传点击
   */
  uploadExcel() {
    const upload: any = this.$refs.uploadExcel;
    upload.click()
  }
}
